import { useEffect } from 'react';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { useToast } from '@/hooks/use-toast';
import { listarRelatoriosApi } from '../api/ListarRelatoriosApi';
import { hasGestorSelecionado } from '../api/shared';
import type { ListarRelatoriosFiltros, ListarRelatoriosResponse } from '../types';

export function useListarRelatorios(
  filtros?: ListarRelatoriosFiltros,
  options?: Omit<UseQueryOptions<ListarRelatoriosResponse, Error>, 'queryKey' | 'queryFn'>
) {
  const { toast } = useToast();

  const query = useQuery<ListarRelatoriosResponse, Error>({
    queryKey: ['relatorios', 'listar', filtros],
    queryFn: () => listarRelatoriosApi(filtros),
    staleTime: 0,
    refetchOnMount: true,
    ...options,
    enabled: (options?.enabled ?? true) && hasGestorSelecionado(),
  });

  useEffect(() => {
    if (!query.error) return;
    toast({
      variant: 'destructive',
      title: 'Erro ao carregar relatórios',
      description: 'Não foi possível carregar a lista de relatórios.',
    });
  }, [query.error, toast]);

  return query;
}
